import styled from 'styled-components';
import {accentColorTertiary, fontColorSecond} from "../../../../assets/styledAssets/vars";
import {StyledRadioButton} from "../../../../components/FormField/styles";

export const StyledWrap = styled.div`
  display:flex;
  width:100%;
  justify-content:space-between;
  align-items:center;
  border-radius:1rem;
  transition:.2s;
  padding:2rem 1.2rem;
  margin-bottom:1rem;
  margin-top:1.2rem;
  cursor:pointer;
  &:hover{
    background-color:${accentColorTertiary};
  }
`;

export const LocalStyledRadioButton = styled(StyledRadioButton)`
  + .k-radio-label{
    color: ${fontColorSecond};
    font-size:1.4rem;
    margin-right:1.2rem;
    display: none;
  }
   &:checked + .k-radio-label{
    display: block;
  }
`;
